import React, { useState } from 'react';
import { CacheContext} from '.';
import PropTypes from 'prop-types';


const CacheContextProvider = ({ children }) => {
    const [ cachedParties, setCachedParties ] = useState([]);
    const [ activeParty, setActiveParty ] = useState({isHistory: false});

    const context = {
        cachedParties,
        setCachedParties,
        activeParty,
        setActiveParty
    }

    return (
        <CacheContext.Provider value={context}>
            {children}
        </CacheContext.Provider>
    )

 };

 CacheContextProvider.propTypes = {
    children: PropTypes.object
}

 export default CacheContextProvider;

